import { useCallback, useRef, useState } from 'react';

/**
 * Общий тип для адаптера серверной валидации.
 * withValidateForm(obj) из laravel-request ожидает объект с state.formErrors и setState.
 * Используется в useLoginForm, useRegisterForm, useForgotEmailForm/useForgotCodeForm для передачи в саги.
 */
export interface ValidateFormRefState {
  formErrors?: Record<string, string[]>;
  [key: string]: unknown;
}

export interface ValidateFormRefObject {
  state: ValidateFormRefState;
  setState: (
    updater: (state: { formErrors: Record<string, string[]> }) => {
      formErrors: Record<string, string[]>;
    }
  ) => void;
}

/**
 * Хук для форм, которые ещё не переведены на TanStack Form.
 * Используется в RoboadvisorSubscribe (прямой вызов Api без саг).
 */
export function useAuthForm() {
  const [formErrors, setFormErrors] = useState<Record<string, string[]>>({});

  const getError = useCallback(
    (fieldName: string): string | undefined => {
      if (formErrors?.[fieldName]?.length > 0) return formErrors[fieldName][0];
      return undefined;
    },
    [formErrors]
  );

  const validateFormRef = useRef<ValidateFormRefObject>({
    state: { formErrors: {} },
    setState: (updater) => {
      if (typeof updater === 'function') {
        setFormErrors((prev) => {
          const next = updater({ formErrors: prev });
          return next?.formErrors ?? prev;
        });
      }
    },
  });
  validateFormRef.current.state = { formErrors };

  return {
    formErrors,
    setFormErrors,
    getError,
    validateFormRef,
  };
}
